import { render, staticRenderFns } from "./MultipleFolderDeleteModal.vue?vue&type=template&id=083ba92e"
import script from "./MultipleFolderDeleteModal.vue?vue&type=script&lang=js"
export * from "./MultipleFolderDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083ba92e')) {
      api.createRecord('083ba92e', component.options)
    } else {
      api.reload('083ba92e', component.options)
    }
    module.hot.accept("./MultipleFolderDeleteModal.vue?vue&type=template&id=083ba92e", function () {
      api.rerender('083ba92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/MultipleFolderDeleteModal.vue"
export default component.exports